<template>
  <div @keyup.enter.prevent="setPassword">
    <div class="title"> Установка нового пароля </div>

    <UiFakeInputs />

    <!-- Email input -->
    <form-group :validator="$v.form.email" :server-errors="serverError('email')">
      <template slot-scope="{ attributes }">
        <UiInputText
          v-model="form.email"
          disabled
          placeholder="Корпоративный email"
          type="text"
          inputmode="email"
          autocapitalize="off"
          autocorrect="off"
          :class="attributes.class"
        >
        </UiInputText>
      </template>
    </form-group>

    <!-- New password input -->
    <form-group :validator="$v.form.password" :server-errors="serverError('password')">
      <template slot-scope="{ attributes }">
        <UiInputText
          id="new-password"
          ref="password"
          v-model="form.password"
          placeholder="Новый пароль"
          type="password"
          autocapitalize="off"
          autocorrect="off"
          autocomplete="new-password"
          :class="attributes.class"
          password-reveal
        />
      </template>
    </form-group>

    <!-- Same password input -->
    <form-group
      :validator="$v.form.password_confirmation"
      :server-errors="serverError('password_confirmation')"
    >
      <template slot-scope="{ attributes }">
        <UiInputText
          ref="password_confirmation"
          v-model="form.password_confirmation"
          placeholder="Повторите новый пароль"
          type="password"
          autocapitalize="off"
          autocorrect="off"
          :class="attributes.class"
          password-reveal
        />
      </template>
    </form-group>

    <div class="footer">
      <UiButton
        :disabled="trySetNewPassword"
        :class="['button', 'is-blue', { 'is-loading': trySetNewPassword }]"
        @click="setPassword"
      >
        Установить пароль
      </UiButton>

      <UiLink :to="{ name: 'login' }"> Страница входа </UiLink>
    </div>
  </div>
</template>

<script>
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'

import validationHelpers from '@/mixins/validationHelpers.js'
import {
  requireBigAlpha,
  requireSmallAlpha,
  requireNum,
  onlyAlphaAndSpecSymbols,
} from '@/mixins/customValidators.js'

import { AuthService } from '@/services/auth.service'

import UiButton from '@/components/UiButton.vue'
import UiInputText from '@/components/UiInputText.vue'
import UiLink from '@/components/UiLink.vue'
import UiFakeInputs from '@/components/UiFakeInputs.vue'

export default {
  components: {
    UiButton,
    UiInputText,
    UiLink,
    UiFakeInputs,
  },
  mixins: [validationHelpers],
  data() {
    return {
      trySetNewPassword: false,

      form: {
        email: '',
        password: '',
        password_confirmation: '',
        key: this.$route.query.key,
      },
    }
  },
  mounted() {
    this.form.email = this.$route.query.email
  },
  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(8),
        requireBigAlpha,
        requireSmallAlpha,
        requireNum,
        onlyAlphaAndSpecSymbols,
      },
      password_confirmation: {
        required,
        sameAs: sameAs('password'),
      },
    },
  },
  methods: {
    async setPassword() {
      this.$v.form.$touch()
      this.clearFormServerErrors()

      if (this.$v.form.$invalid) return

      try {
        this.trySetNewPassword = true

        await AuthService.setPassword(this.form)

        this.$store.commit('toast/NEW', { type: 'success', message: 'Пароль успешно изменен.' })

        await this.$router.push({ name: 'login' })
      } catch (error) {
        this.$store.commit('toast/NEW', { type: 'error', message: error })

        this.formServerErrors = error.formServerErrors
      } finally {
        this.trySetNewPassword = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  @include createFlex(flexbox, nowrap, row, space-between, center, center);
}
</style>
